import './StartWrtingComp.css'
import image1 from './image 1.png'
import image2 from './image 2.png'
import image3 from './image 3.png'
import { useState} from 'react'
// import Web3 from 'web3';
// import { Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'
export default function StartWritingPaid() {
  const [validaddresses1,setaddresses1]=useState(false);
  const [validaddresses2,setaddresses2]=useState(false);
  const [validaddresses3,setaddresses3]=useState(false);
  const [validaddresses4,setaddresses4]=useState(false);
  const [validaddresses5,setaddresses5]=useState(false);
  const [validaddresseserror1,setaddresseserror1]=useState('');
  const [validaddresseserror2,setaddresseserror2]=useState('');
  const [validaddresseserror3,setaddresseserror3]=useState('');
  const [validaddresseserror4,setaddresseserror4]=useState('');
  const [validaddresseserror5,setaddresseserror5]=useState('');
  const navigate = useNavigate();

  const approve_page=()=>{
    if (((emailErrorb1 && emailErrorb2 && emailErrorb3 && emailErrorb6 && emailErrorb7) )){
      if(validaddresses1 && validaddresses2 && validaddresses3 && validaddresses4 && validaddresses5 ){
        navigate('/ApprovePaid');
      }
      else if(validaddresses1 && validaddresses2 && validaddresses3 && (validaddresses4 || validaddresses5) && (emailErrorb5|| emailErrorb4)){
        if(!(localStorage.getItem('trustee3wallet')) || !(localStorage.getItem('trustee4wallet'))){
          navigate('/ApprovePaid');
        }
        else{
          alert('error3');
        }
  
       
       
        
      }
      else if(validaddresses1 && validaddresses2 && validaddresses3){
        if(!(localStorage.getItem('trustee3wallet')) && !(localStorage.getItem('trustee4wallet'))){
          navigate('/ApprovePaid');
        }
        else{
          alert('error2');
        }
      
  
      }
      
     
    }
    else{
      alert('error1');
    }
    
  }

    const handleRadioChange = (event) => {
        const value = event.target.value;
       
        localStorage.setItem('selectedOption', value);
        console.log(localStorage.getItem('selectedOption'));
      };
      const handledaoChange = (event) => {
        const value = event.target.value;
       
        localStorage.setItem('daoname', value);
        console.log(localStorage.getItem('daoname'));
      };
      const EthereumAddress = require('ethereum-address');

      const handlesuccessorwalletChange = (event) => {
        const value = event.target.value;
        localStorage.setItem('successorwallet', value);
        if (value !== '') {
          try{
          const isChecksumValid = EthereumAddress.isChecksumAddress(value);
      
          if (isChecksumValid) {
            console.log('Valid Ethereum address checksum.');
            
            setaddresses1(true);
            setaddresseserror1('');
            // Remove the red outline if address is valid
            event.target.classList.remove('invalid-address');
          } else {
            console.log('Invalid Ethereum address checksum.');
            // Add the red outline if address is invalid
            setaddresses1(false);
            setaddresseserror1('Please enter a valid wallet address*');
            event.target.classList.add('invalid-address');
          }}
          catch(error){
            console.log(error);
          }
        }
      };
      

      const handlesuccessoremailChange = (event) => {
        const value = event.target.value;
        if(value!==''){
          if (validateEmail(value)){
            localStorage.setItem('successoremail', value);
            event.target.classList.remove('invalid-address');
            setEmailError1('');

            setemailErrorb1(true);
          }
          else{
            event.target.classList.add('invalid-address');
            setEmailError1(emailError);
            setemailErrorb1(false);
          }
        }
        
       
        

      };
      const handletrustee1walletChange = (event) => {
        const value = event.target.value;
        localStorage.setItem('trustee1wallet', value);
        if (value !== '') {
          try{
          const isChecksumValid = EthereumAddress.isChecksumAddress(value);
      
          if (isChecksumValid) {
            console.log('Valid Ethereum address checksum.');
            
            setaddresses2(true);
            setaddresseserror2('');
            // Remove the red outline if address is valid
            event.target.classList.remove('invalid-address');
          } else {
            console.log('Invalid Ethereum address checksum.');
            setaddresses2(false);
            setaddresseserror2('Please enter a valid wallet address*');
            // Add the red outline if address is invalid
            event.target.classList.add('invalid-address');
          }}
          catch(error){
            console.log(error);
          }
        }
        else {
          console.log('Address should not be empty.');
          // Add the red outline if address is empty
          event.target.classList.add('invalid-address');
        }
       
        

      };
      const handletrustee1emailChange = (event) => {
        const value = event.target.value;
        
        if(value!==''){
          if (validateEmail(value)){
            localStorage.setItem('trustee1email', value);
            event.target.classList.remove('invalid-address');
            setemailErrorb2(true);
            setEmailError2('');
          }
          else{
            event.target.classList.add('invalid-address');
            setEmailError2(emailError);
            setemailErrorb2(false);
          }
        }
      

      };
      const handletrustee2walletChange = (event) => {
        const value = event.target.value;
        localStorage.setItem('trustee2wallet', value);
        if (value !== '') {
          try{
          const isChecksumValid = EthereumAddress.isChecksumAddress(value);
      
          if (isChecksumValid) {
            console.log('Valid Ethereum address checksum.');
            
            setaddresses3(true);
            setaddresseserror3('');
            // Remove the red outline if address is valid
            event.target.classList.remove('invalid-address');
          } else {
            console.log('Invalid Ethereum address checksum.');
            // Add the red outline if address is invalid
            setaddresses3(false);
            event.target.classList.add('invalid-address');
            setaddresseserror3('Please enter a valid wallet address*');
          }}
          catch(error){
            console.log(error);
          }
        }
        else {
          console.log('Address should not be empty.');
          // Add the red outline if address is empty
          event.target.classList.add('invalid-address');
        }
        
       
      

      };
      const handletrustee2emailChange = (event) => {
        const value = event.target.value;
       
        if(value!==''){
          if (validateEmail(value)){
            localStorage.setItem('trustee2email', value);
            event.target.classList.remove('invalid-address');
            setemailErrorb3(true);
            setEmailError3('');
          }
          else{
            event.target.classList.add('invalid-address');
            setEmailError3(emailError);
            setemailErrorb3(false);
          }
        }

      };
      const handletrustee3walletChange = (event) => {
        const value = event.target.value;
        localStorage.setItem('trustee3wallet', value);
        if (value !== '') {
          try{
          const isChecksumValid = EthereumAddress.isChecksumAddress(value);
      
          if (isChecksumValid) {
            console.log('Valid Ethereum address checksum.');
           
            setaddresses4(true);
            setaddresseserror4('');
            // Remove the red outline if address is valid
            event.target.classList.remove('invalid-address');
          } else {
            console.log('Invalid Ethereum address checksum.');
            // Add the red outline if address is invalid
            event.target.classList.add('invalid-address');
            setaddresseserror4('Please enter a valid wallet address*');
            setaddresses4(false);

             
          }}
          catch(error){
            console.log(error);
          }
        }
        else {
          console.log('Address should not be empty.');
          // Add the red outline if address is empty
          event.target.classList.add('invalid-address');
        }
       
        
        

      };
      const handletrustee3emailChange = (event) => {
        const value = event.target.value;
       
        if(value!==''){
          if (validateEmail(value)){
            localStorage.setItem('trustee3email', value);
            event.target.classList.remove('invalid-address');
            setemailErrorb4(true);
            setEmailError4('');
          }
          else{
            event.target.classList.add('invalid-address');
            setEmailError4(emailError);
            setemailErrorb4(false);
          }
        }

      };
      const handletrustee4walletChange = (event) => {
        const value = event.target.value;
        localStorage.setItem('trustee4wallet', value);
        if (value !== '') {
          try{
          const isChecksumValid = EthereumAddress.isChecksumAddress(value);
      
          if (isChecksumValid) {
            console.log('Valid Ethereum address checksum.');
            
            setaddresses5(true);
            setaddresseserror5('');
            // Remove the red outline if address is valid
            event.target.classList.remove('invalid-address');
          } else {
            console.log('Invalid Ethereum address checksum.');
            // Add the red outline if address is invalid
            setaddresses5(false);
            setaddresseserror5('Please enter a valid wallet address*');
            event.target.classList.add('invalid-address');
             
          }}
          catch(error){
            console.log(error);
          }
        }
        else {
          console.log('Address should not be empty.');
          // Add the red outline if address is empty
          event.target.classList.add('invalid-address');
        }
        
       
      };
      const handletrustee4emailChange = (event) => {
        const value = event.target.value;
       
        if(value!==''){
          if (validateEmail(value)){
            localStorage.setItem('trustee4email', value);
            event.target.classList.remove('invalid-address');
            setemailErrorb5(true);
            setEmailError5('');
          }
          else{
            event.target.classList.add('invalid-address');
            setEmailError5(emailError);
            setemailErrorb5(false);
          }
        }

      };
      const handlenftemailChange = (event) => {
        const value = event.target.value;
       
        if(value!==''){
          if (validateEmail(value)){
            // localStorage.setItem('trustee4email', value);
            event.target.classList.remove('invalid-address');
            setEmailError6('');
            setemailErrorb6(true);
          }
          else{
            event.target.classList.add('invalid-address');
            setEmailError6(emailError);
            setemailErrorb6(false);
          }
        }

      };
      const handleuseremailChange = (event) => {
        const value = event.target.value;
       
        if(value!==''){
          if (validateEmail(value)){
            // localStorage.setItem('trustee4email', value);
            event.target.classList.remove('invalid-address');
            setEmailError7('');
            setemailErrorb7(true);
          }
          else{
            event.target.classList.add('invalid-address');
            setEmailError7(emailError);
            setemailErrorb7(false);
          }
        }

      };
      const handletokenChange = (event) => {
        const value = event.target.value;
       
        localStorage.setItem('token', value);

      };
      const handleseltokenChange = (event) => {
        const value = event.target.value;
       
        localStorage.setItem('seltoken', value);

      };
      const handlenfttokenChange = (event) => {
        const value = event.target.value;
       
        localStorage.setItem('nfttoken', value);

      };
    

        const [trusteeCount, setTrusteeCount] = useState(2);
        const [tokenCount, setTokenCount] = useState(0);
        const [nfttokenCount, setnftTokenCount] = useState(0);
      
        const addTrustee = () => {
          if (trusteeCount === 2 && validaddresses3 && validaddresses2) {
            setTrusteeCount(3);
          } else if (trusteeCount === 3 && validaddresses4 && validaddresses3 && validaddresses2) {
            setTrusteeCount(4);
          }
        }
        const removeTrustee = (index) => {
            setTrusteeCount(trusteeCount - 1);
            // Perform any additional removal logic here
          };
          const addToken = () => {
            if (tokenCount === 0) {
              setTokenCount(1);
            } else if (tokenCount === 1) {
              setTokenCount(2);
            }
          }
          const removeToken = (index) => {
              setTokenCount(tokenCount - 1);
              // Perform any additional removal logic here
            };
            const addnftToken = () => {
                if (nfttokenCount === 0) {
                  setnftTokenCount(1);
                } else if (nfttokenCount === 1) {
                  setnftTokenCount(2);
                }
              }
              const removenftToken = (index) => {
                  setnftTokenCount(nfttokenCount - 1);
                  // Perform any additional removal logic here
                };
                const validateEmail = (email) => {
                  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              
                  if (!emailPattern.test(email)) {
                    setEmailError('Please enter a valid email address*');
                    return false;
                  }
                  
                  setEmailError('');
                  return true;
                };
                const [emailError1, setEmailError1] = useState('');
                const [emailError, setEmailError] = useState('');
                const [emailError2, setEmailError2] = useState('');
                const [emailError3, setEmailError3] = useState('');
                const [emailError4, setEmailError4] = useState('');
                const [emailError5, setEmailError5] = useState('');
                const [emailError6, setEmailError6] = useState('');
                const [emailError7, setEmailError7] = useState('');
                const [emailErrorb1, setemailErrorb1] = useState(false);
                
                const [emailErrorb2, setemailErrorb2] = useState(false);
                const [emailErrorb3, setemailErrorb3] = useState(false);
                const [emailErrorb4, setemailErrorb4] = useState(false);
                const [emailErrorb5, setemailErrorb5] = useState(false);
                const [emailErrorb6, setemailErrorb6] = useState(false);
                const [emailErrorb7, setemailErrorb7] = useState(false);
    return (
      
        <div className='startwritingcard'>
            
            <h1>SELECT BLOCKCHAIN</h1>
            <div className="container">
                <form id='startWritingForm'>
                    <div className="radio-tile-group mb-4 mt-3">
                        <div className="input-container">
                            <input id="walk" className="radio-button" type="radio" name="radio" onChange={handleRadioChange} value='Cardano' />
                            <div className="radio-tile rounded-pill">
                                <div className="icon px-2 py-1">
                                    <img src={image1} alt="Cardano" />
                                </div>
                                <label htmlFor="walk" className="radio-tile-label px-2">Cardano</label>
                            </div>
                        </div>

                        <div className="input-container">
                            <input id="bike" className="radio-button" type="radio" name="radio" onChange={handleRadioChange} value='Ethereum' />
                            <div className="radio-tile rounded-pill">
                                <div className="icon px-2 py-1">
                                    <img src={image2} alt="Ethereum" />

                                </div>
                                <label htmlFor="bike" className="radio-tile-label px-2">Ethereum</label>
                            </div>
                        </div>

                        <div className="input-container">
                            <input id="drive" className="radio-button" type="radio" name="radio" onChange={handleRadioChange} value='Polygon'/>
                            <div className="radio-tile rounded-pill">
                                <div className="icon px-2 py-1">
                                    <img src={image3} alt="Polygon" />

                                </div>
                                <label htmlFor="drive" className="radio-tile-label px-2">Polygon</label>
                            </div>
                        </div>
                    </div>

                    <div className="mb-4">
                        <label htmlFor="dao_name" className="form-label">NAME YOUR ShareitLater DAO</label>
                        <input required style={{background:'hwb(186 24% 10%)',color:'black'}} type="text" className="form-control bg-yellow" id="dao_name" placeholder="Your DAO name" onChange={handledaoChange} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="s_wallet" className="form-label">ENTER YOUR SUCCESSORS’ CRYPTO WALLET ADDRESSES
                            <br />
                            <span className="form-label px-3">1 successor on free subscription</span>
                        </label>

                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-3" id="s_wallet" placeholder="SUCCESSORS’ Wallet" onChange={handlesuccessorwalletChange} />
                        {validaddresseserror1 && <p style={{ color: 'red' }}>Please enter a valid wallet address*</p>}
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow" id="s_email" placeholder="SUCCESSORS’ Email " onChange={handlesuccessoremailChange} />
                        {emailError1 && <p style={{ color: 'red' }}>{emailError1}</p>}
                    </div>
                    <div className="mb-4">
                        <label htmlFor="t_wallet" className="form-label">ENTER YOUR TRUSTEES’ CRYPTO WALLET ADDRESSES

                            <br />
                            <span className="form-label px-3">2-4 Trustees
                            </span>
                        </label>

                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-3" id="t_wallet 1_t" placeholder="TRUSTEES’ Wallet" onChange={handletrustee1walletChange}/>
                        {validaddresseserror2 && <p style={{ color: 'red' }}>Please enter a valid wallet address*</p>}
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-4" id="t_email 1_e" placeholder="TRUSTEES’ Email " onChange={handletrustee1emailChange}/>
                        {emailError2 && <p style={{ color: 'red' }}>{emailError2}</p>}
                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-3" id="t_wallet 2_t" placeholder="TRUSTEES’ Wallet" onChange={handletrustee2walletChange}/>
                        {validaddresseserror3 && <p style={{ color: 'red' }}>Please enter a valid wallet address*</p>}
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-4" id="t_email 2_e" placeholder="TRUSTEES’ Email " onChange={handletrustee2emailChange}/>
                        {emailError3 && <p style={{ color: 'red' }}>{emailError3}</p>}
                        { (trusteeCount>=3 ) && (
                            <>
                             <FontAwesomeIcon icon={faTimes} onClick={() => removeTrustee(3)}  style={{ fontSize: '1.5rem', cursor: 'pointer', marginRight: '0.5rem' ,left:'88%',position:'sticky' ,background:'black',borderRadius:'4px'}}/>
                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-3" id="t_wallet 3_t" placeholder="TRUSTEES’ Wallet" onChange={handletrustee3walletChange} />
                        {validaddresseserror4 && <p style={{ color: 'red' }}>Please enter a valid wallet address*</p>}
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-4" id="t_email 3_e" placeholder="TRUSTEES’ Email " onChange={handletrustee3emailChange} />
                        {emailError4 && <p style={{ color: 'red' }}>{emailError4}</p>}
                       </> )}
                       { trusteeCount>=4 && (
                            <>
                            <FontAwesomeIcon icon={faTimes} onClick={() => removeTrustee(4)}  style={{ fontSize: '1.5rem', cursor: 'pointer', marginRight: '0.5rem',left:'88%',position:'sticky',background:'black',borderRadius:'4px'  }}/>
                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-3" id="t_wallet 4_t" placeholder="TRUSTEES’ Wallet" onChange={handletrustee4walletChange} />
                        {validaddresseserror5 && <p style={{ color: 'red' }}>Please enter a valid wallet address*</p>}
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow" id="t_email 4_e" placeholder="TRUSTEES’ Email " onChange={handletrustee4emailChange} />
                        {emailError5 && <p style={{ color: 'red' }}>{emailError5}</p>}
                        </> )}
                        </div>
                        
                        { trusteeCount<4 && (
                    <div className="mb-4 d-flex align-items-center justify-content-center">
                        <button className="btn rounded-pill px-5
                        " id='addtrustee' onClick={addTrustee} type="button">
                            ADD TRUSTEE
                        </button>
                    </div>
                        )}
                    <div className="mb-4">
                        <label htmlFor="choose_tokens" className="form-label">CHOOSE ERC20 TOKENS YOU WISH TO ENTRUST</label>
                        <select id="choose_tokens" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-select bg-yellow" onChange={handleseltokenChange}>
                            <option>Select tokens from the list</option>
                            <option>...</option>
                        </select>
                    </div>

                    <div className="mb-4">
                        <label htmlFor="token" className="form-label">If your token is not on the list, add it by yourself
                        </label>
                        { tokenCount>=1 && (
                            <>
                             
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                           
                            <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-4" id="token" placeholder="Token(0x..)" onChange={handletokenChange}/>
                           <p style={{margin:'0 10px 0px 10px'}}>#Token1</p>
                           <FontAwesomeIcon icon={faTimes} onClick={() => removeToken(1)}  style={{ fontSize: '1.5rem', cursor: 'pointer', marginRight: '0.5rem',left:'88%',position:'sticky',background:'black',borderRadius:'4px'  }}/> </div>
                        </> )}
                        { tokenCount>=2 && (
                            <>
                            
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                           
                            <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow" id="token" placeholder="Token(0x..)" />
                            <p style={{margin:'0 10px 0px 10px'}}>#Token2</p>
                            <FontAwesomeIcon icon={faTimes} onClick={() => removeToken(1)}  style={{ fontSize: '1.5rem', cursor: 'pointer', marginRight: '0.5rem',left:'88%',position:'sticky',background:'black',borderRadius:'4px'  }}/> </div>
                        </> )}
                        
                    </div>
                    { tokenCount<2 && (
                    <div className="mb-4 d-flex align-items-center justify-content-center">
                        <button type='button' className="btn rounded-pill px-5" onClick={addToken}>
                            ADD TOKEN
                        </button>
                    </div>
                    )}
                    <div className="mb-4">
                        <label className="form-label">ADD NFT ERC721 TOKENS YOU WISH TO ENTRUST
                        </label>
                        { nfttokenCount>=1 && (
                            <>
                             
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                           
                            <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-4" id="token" placeholder="Token (0x..)" onChange={handlenfttokenChange} />
                           <p style={{margin:'0 10px 0px 10px'}}>#Token1</p>
                           <FontAwesomeIcon icon={faTimes} onClick={() => removenftToken(1)}  style={{ fontSize: '1.5rem', cursor: 'pointer', marginRight: '0.5rem',left:'88%',position:'sticky',background:'black',borderRadius:'4px'  }}/> </div>
                           <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-3" id="t_wallet 1_t" placeholder="NFT-721 SUCCESSOR" />
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-4" id="t_email 1_e" placeholder="NFT-721 SUCCESSOR EMAIL" onChange={handlenftemailChange}/>
                        {emailError6 && <p style={{ color: 'red' }}>{emailError6}</p>}
                        </> )}
                    </div>
                    { nfttokenCount<1 && (
                            <>
                    <div className="mb-4 d-flex align-items-center justify-content-center">
                        <button type='button' className="btn rounded-pill px-5" onClick={addnftToken}>
                            ADD NFT
                        </button>
                    </div>
                    </> )}
                    <div className="mb-4">
                        <label htmlFor="email" className="form-label">ENTER YOUR EMAIL
                        </label>
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow" id="email" onChange={handleuseremailChange}/>
                        {emailError7 && <p style={{ color: 'red' }}>{emailError7}</p>}
                    </div>

                    <div className="mb-4 d-flex align-items-center justify-content-center">
                   
                        <button type='button' className="btn rounded-pill px-5" 
                        onClick={approve_page}
                        >
                           
                            NEXT STAGE
                            </button>
                       
                       </div>
                            
                          
                            
                            
                            
                      
                   
                </form>


            </div>

        </div >
    )
}
